
import { Component, Prop, Vue } from 'vue-property-decorator';

import MapScrollguard from './map-scrollguard.vue';

@Component
export default class RampMapV extends Vue {
    @Prop() config: string | undefined;
    @Prop() shadow: boolean | undefined;
    @Prop() height: string | undefined;
    @Prop() id: string | undefined;
    @Prop() version: number | undefined;

    shadowValue = false;

    mounted() {
        this.shadowValue = this.shadow ?? false;

        this.$el.querySelector('#ramp-map')?.setAttribute('id', this.id ?? 'ramp-map');

        const updatedID = this.id === undefined ? '#ramp-map' : '#' + this.id;

        if (this.height) {
            this.$el.querySelector(updatedID)?.classList.add(this.height);
            this.$el.querySelector(updatedID)?.classList.remove('h-[725px]');
        }

        const RAMP = this.version === 4 ? (window as any).RAMP4 : (window as any).RAMP;

        const _window = window as any;

        // if RAMP API is not ready yet, loop-wait until it's loaded
        if (!RAMP) {
            window.setInterval(() => this.mounted(), 500);
            return;
        }

        if (this.version === 4) {
            RAMP.createInstance(this.$el.querySelector(updatedID), require(`/public/config/ramp4/${this.config}.json`));
        } else if (this.version === 3) {
            new RAMP.Map(this.$el.querySelector(updatedID), `./config/ramp3/${this.config ? this.config : '0'}.json`);
        }

        _window.$('.flex.relative.z-10.shadow-lg.justify-center').css({
            display: 'flex'
        });
        _window.$('.text-white').css({
            display: 'block'
        });

        if (this.config === 'plugins') {
            this.$el.querySelector(updatedID)?.setAttribute('rv-plugins', 'swiper, draw');
        }

        if (this.id === `ramp-map${this.version}-5`) {
            this.$el.querySelector(updatedID)?.classList.add('w-[340px]');
        }

        if (this.id === `ramp-demo${this.version}-mobile`) {
            if (this.version === 3) {
                new RAMP.Map(this.$el.querySelector('#ramp-map2'), `./config/ramp3/mobile.json`);
                new RAMP.Map(this.$el.querySelector('#ramp-map3'), `./config/ramp3/mobile.json`);
            } else if (this.version === 4) {
                RAMP.createInstance(this.$el.querySelector('#ramp-map2'), require(`/public/config/ramp4/mobile.json`));
                RAMP.createInstance(this.$el.querySelector('#ramp-map3'), require(`/public/config/ramp4/mobile.json`));
            }

            _window.$('#medium-text').css({
                display: 'block',
                'margin-top': '2%'
            });
            _window.$('#text1').css({
                float: 'left',
                width: '15%',
                'margin-right': '2%',
                'margin-left': '2%'
            });
            _window.$('#text2').css({
                float: 'right',
                width: '15%',
                'margin-left': '2%',
                'margin-right': '2%'
            });
            _window.$('#ramp-map2').css({
                display: 'block',
                height: '625px',
                width: '50%',
                'margin-top': '2%',
                'margin-bottom': '2%',
                'margin-left': '25%'
            });
            _window.$('#ramp-map3').css({
                display: 'block',
                height: '725px',
                width: '20%',
                'margin-top': '2%',
                'margin-bottom': '2%',
                'margin-left': '40%'
            });
        } else if (this.config === 'sample_implement') {
            _window.$('.flex.relative.z-10.shadow-lg.justify-center').css({
                display: 'none'
            });
            _window.$('.text-white').css({
                display: 'none'
            });
            _window.$(updatedID).css({
                width: '50%',
                'margin-left': '25%'
            });
        }

        window.scrollTo(0, 0);
        if (this.version === 3 && this.$route.name === 'Home') {
            RAMP.mapAdded.subscribe(async (mapi: any) => {
                const scrollguardComponent = new Vue({
                    render: (h) =>
                        h('map-scrollguard', {
                            props: { _mapi: mapi }
                        }),
                    components: {
                        //eslint-disable-next-line
                        'map-scrollguard': MapScrollguard
                    },
                    i18n: this.$i18n
                }).$mount();

                const innerShell = this.$el.querySelector('.rv-inner-shell')!;

                // insert the scrollguard as the first child of the inner shell
                // this will place the guard above the map, but below all other RAMP controls
                // when the guard is active, it grays out the map, but not the controls
                innerShell.insertBefore(scrollguardComponent.$el, innerShell.firstChild);
            });
        }
    }
}
